'use strict';

const AngularHelpers=require('../../../dist-es6/client/angularCommon/angularHelpers');

module.exports=AngularHelpers.registerModule({
name:'fdc.services',
components:[
require('./appVersionService'),
require('./breadcrumbsService'),
require('./cookieRefresherService'),
require('./dashboardDataService'),
require('./dateService'),
require('./drivePlanService'),
require('./displaySettingsService'),
require('./elementService'),
require('./errorHandlers'),
require('./forecastDataService'),
require('./fatigueTrendsDataService'),
require('./fatigueMeterTypeContentProviderService'),
require('./fleetIncidentsDataService'),
require('./flightMonitorDataService'),
require('./groupBasedDataHelperService'),
require('./groupsCommandAndQueryService'),
require('./groupsPopulationService'),
require('./groupTreeService'),
require('./groupUpdateErrorHandlingService'),
require('./heatmapService'),
require('./intervalService'),
require('./notificationService'),
require('./organizationDefaultsService'),
require('./paramSyncService'),
require('./personalFatigueThresholdService'),
require('./personalIncidentsService'),
require('./personalScheduleDataService'),
require('./personService'),
require('./progressService'),
require('./rasterizationService'),
require('./redirectionService'),
require('./recursionService'),
require('./scheduleService'),
require('./sidebarScrollingService'),
require('./socketService'),
require('./statisticalDisplayDataService'),
require('./scheduleRowScrollingService'),
require('./statisticsService'),
require('./timeFormattingService'),
require('./timeZoneService'),
require('./tripPlanningService'),
require('./tooltipService'),
require('./uiCommandFactory'),
require('./uncaughtErrorHandler'),
require('./userService'),
require('./waypointViewModelService')]});
//# sourceMappingURL=index.js.map
